import { render, staticRenderFns } from "./EditAutomationRule.vue?vue&type=template&id=5d4ce21b&scoped=true&"
import script from "./EditAutomationRule.vue?vue&type=script&lang=js&"
export * from "./EditAutomationRule.vue?vue&type=script&lang=js&"
import style0 from "./EditAutomationRule.vue?vue&type=style&index=0&id=5d4ce21b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ce21b",
  null
  
)

export default component.exports